export const text = {
  SplashImage: "Merkafbeelding",
  TaskPoint: "Taak punten",
  SplashTime: "Weergaveduur (in seconden)",
  GoalAttachmentSize: "Maximale bijlagegrootte (in MB)",
  AssetTimebookingBuffer: "Buffer voor tijdsboeking van middel (in minuten)",
  MinimumAssetBookingTime: "Minimale middel boekingstijd (in minuten)",
  OnboardingVideo: "Onboarding Video",
  Thumbnail: "Afbeelding",
  Simmesettingupdatedsuccessfully: "Simme instellingen succesvol bijgewerkt!",
  OnboardingSettingupdatedsuccessfully:
    "Onboarding instellingen succesvol bijgewerkt!",
  SimmeSettings: "Simme instellingen",
  OnboardingSetting: "Onboarding instellingen",
  SelectBrandColor: "Kies merkkleur",
  OtpExpirationTime: "OTP-verval tijd",
};
